import React, { useState } from "react";
import { useGet } from "../../customHooks/useGet";
import { usePost } from "../../customHooks/usePost";
import SchoolTable from "../Schools/SchoolsTable";
import AddRepresentative from "./AddRepresentative";
import SchoolForm from "./SchoolForm";
import { FaPlus, FaSearch } from "react-icons/fa";
import "../../css/Schools/Schools.css";

const API_BASE_URL = "https://ectech-software.com.ar/api/academy/schools";

function Schools() {
  const [page, setPage] = useState(0);
  const [schoolIdToAdd, setSchoolIdToAdd] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { data, loading, error, refetch } = useGet(`${API_BASE_URL}?page=${page}&size=10`);
  const { executePost, loading: postLoading, error: postError } = usePost();

  const handlePageChange = (direction) => {
    setPage((prev) =>
      direction === "prev" && prev > 0 ? prev - 1 :
      direction === "next" && data?.totalPages > prev + 1 ? prev + 1 : prev
    );
  };

  const handleCreateSchool = async (newSchool) => {
    try {
      const createdSchool = await executePost(API_BASE_URL, newSchool);
      if (!createdSchool || !createdSchool.id) throw new Error("No se recibió una respuesta válida del servidor.");

      await refetch(); // Refresca la lista de escuelas
      setSearchQuery(""); // Restablecer la búsqueda
      setShowForm(false);
    } catch (error) {
      console.error("Error al crear la escuela:", error);
      alert("Hubo un problema al crear la escuela. Intenta nuevamente.");
    }
  };

  const handleSearch = () => {
    if (!searchQuery) return data?.content; // Si no hay búsqueda, retorna todas las escuelas
    return data?.content.filter((school) =>
      school.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  if (loading) return <p className="alert alert-info text-center">Cargando escuelas...</p>;
  if (error) return <p className="alert alert-danger text-center">Error al obtener escuelas: {error.message}</p>;

  const filteredSchools = handleSearch();

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Gestión de Escuelas</h1>

  

      <SchoolTable
        schools={filteredSchools || []} // Mostrar las escuelas filtradas
        totalPages={Math.ceil(filteredSchools.length / 10) || 1} // Total de páginas basado en la longitud de escuelas filtradas
        onPageChange={handlePageChange}
        onAddRepresentative={(schoolId) => {
          setSchoolIdToAdd(schoolId);
          setShowModal(true);
        }}
      />

      {showModal && (
        <AddRepresentative
          schoolId={schoolIdToAdd}
          onClose={() => setShowModal(false)}
          onAddUser={refetch}
        />
      )}

      {!showModal && !showForm && (
        <button
          className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
          onClick={() => setShowForm(true)}
          aria-label="Nueva escuela"
          title="Agregar nueva escuela"
          style={{
            background: "linear-gradient(135deg, #007bff, #6610f2)",
            color: "white",
            fontSize: "1.5rem",
            border: "none",
            width: "60px",
            height: "60px",
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1050,
            transition: "transform 0.2s ease, box-shadow 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.1)";
            e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
          }}
        >
          <FaPlus size={24} />
        </button>
      )}

      {showForm && (
        <SchoolForm
          onSubmit={handleCreateSchool}
          setShowForm={setShowForm}
          updateSchools={refetch} // Agregado aquí para pasar la función updateSchools
        />
      )}
    </div>
  );
}

export default Schools;
